import React, { useState, useEffect, useRef } from "react"
import {
  Form,
  Button,
  Row,
  Col,
  Container,
  Spinner,
  FormGroup,
  Label,
  Input,
  Nav,
  NavLink,
  NavItem,
  TabContent, TabPane
} from "reactstrap"
import { withTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom"
import { get, handleApiError, patch, post, upload } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import classnames from "classnames"
import toastr from "toastr"

const BagForm = props => {
  const navigate = useNavigate();
  const objectParams = useParams();
  const [id, setId] = useState(objectParams.id);
  const [loading, setLoading] = useState(!!id);
  const [formData, setFormData] = useState({
    realPrice: 0,
    price: 0,
    image: null,
    translations: {
      fr: { name: "", description: "" },
      en: { name: "", description: "" },
      ar: { name: "", description: "" },
    },
  });
  const [activeTab, setActiveTab] = useState("fr");
  const [previewPhoto, setPreviewPhoto] = useState(null);
  const [imageChanged, setImageChanged] = useState(false);
  const [imageError, setImageError] = useState("");
  const [isDraggingImage, setIsDraggingImage] = useState(false);
  const fileInputRef = useRef(null);
  const flags = {
    fr: "🇫🇷",
    en: "🇬🇧",
    ar: "🇲🇦",
  };

  const fetchDataBag = async (id) => {
    let response = await get(`bags/${id}`);
    if (200 === response.status) {
      response = response.data;
      setFormData({
        realPrice: response.realPrice,
        price: response.price,
        image: response.image,
        translations: {
          fr: response.translations?.fr ? {locale: 'fr', name: response.translations?.fr.name, description: response.translations?.fr.description} : { name: "", description: "" },
          en: response.translations?.en ? {locale: 'en', name: response.translations?.en.name, description: response.translations?.en.description} : { name: "", description: "" },
          ar: response.translations?.ar ? {locale: 'ar', name: response.translations?.ar.name, description: response.translations?.ar.description} : { name: "", description: "" },
        },
      });
    }

    setLoading(false);
  }

  useEffect(() => {
    if (id) {
      fetchDataBag(id);
    }
  }, [id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleTranslationChange = (e, lang, field) => {
    setFormData({
      ...formData,
      translations: {
        ...formData.translations,
        [lang]: {
          ...formData.translations[lang],
          'locale': lang,
          [field]: e.target.value,
        },
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {

        try {
          const response = await patch(`/bags/${id}`, {
            "realPrice": parseFloat(formData.realPrice),
            "price": parseFloat(formData.price),
            "translations": formData.translations
          });

          if (200 === response.status) {
            if (imageChanged) {
              const formDataImage = {'image': formData.image};
              const responseUpload = await upload(`bags/${id}/image/upload`, formDataImage);
              if (200 === responseUpload.status && 'ok' === responseUpload.data.result) {
                setImageChanged(false);
              }
            }
            toastr.info('Vos modifications ont été enregistrées avec succès.', '');
          }
        } catch (error) {
          handleApiError(error.response.data);
        }
      } else {

        try {
          const response = await post("/bags", {
            "realPrice": parseFloat(formData.realPrice),
            "price": parseFloat(formData.price),
            "translations": formData.translations
          });

          if (201 === response.status) {
            setId(response.data.id);
            if (imageChanged) {
              const formDataImage = {'image': formData.image};
              const responseUpload = await upload(`bags/${response.data.id}/image/upload`, formDataImage);
              if (200 === responseUpload.status && 'ok' === responseUpload.data.result) {
                setImageChanged(false);
              }
            }
            toastr.info('Vos modifications ont été enregistrées avec succès.', '');
          }
        } catch (error) {
          handleApiError(error.response.data);
        }
      }
      //navigate("/bags");
    } catch (error) {
      console.error("Erreur lors de la soumission :", error);
    }
  };

  const selectImage = (file) => {
    setImageError("");
    if (!file) return;

    if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
      setImageError("Choisissez une image JPG, PNG ou WEBP.");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setImageError("L’image ne doit pas dépasser 5 Mo.");
      return;
    }

    setFormData({ ...formData, image: file });
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewPhoto(reader.result);
      setImageChanged(true);
    };
    reader.readAsDataURL(file);
  };

  const handleImageChange = (e) => {
    selectImage(e.target.files[0]);
  };

  const handleImageDrop = (e) => {
    e.preventDefault();
    setIsDraggingImage(false);
    selectImage(e.dataTransfer.files[0]);
  };

  const triggerFileSelect = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Chargement...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={id
              ? props.t("Modifier les informations du panier")
              : props.t("Ajouter un panier")
            }
            breadcrumbItem={id
              ? props.t("Modifier les informations du panier")
              : props.t("Ajouter un panier")
            }
          />

          <div className="mt-2">
            <Form onSubmit={handleSubmit} encType="multipart/form-data" method="POST">
              <div className="mt-3">
                <h5>{props.t("Détails du Panier")}</h5>
                <Row className="mb-2">
                  <Col md={12}>
                    <div className="py-3">
                      <div className="bag-image-upload-heading">
                        <div>
                          <Label className="mb-1 fw-bold">Photo du panier</Label>
                          <p className="text-muted mb-0">Une photo appétissante aide vos paniers à être réservés plus rapidement.</p>
                        </div>
                        {formData.image && (
                          <Button type="button" color="light" className="bag-image-change-button" onClick={triggerFileSelect}>
                            <i className="bx bx-refresh me-1" /> Remplacer
                          </Button>
                        )}
                      </div>

                      <button
                        type="button"
                        className={`bag-image-upload ${formData.image ? "has-image" : ""} ${isDraggingImage ? "is-dragging" : ""}`}
                        onClick={triggerFileSelect}
                        onDragOver={(e) => {
                          e.preventDefault();
                          setIsDraggingImage(true);
                        }}
                        onDragLeave={() => setIsDraggingImage(false)}
                        onDrop={handleImageDrop}
                      >
                        {formData.image ? (
                          <>
                            <img src={previewPhoto || formData.image} alt="Aperçu du panier" />
                            <span className="bag-image-upload-overlay">
                              <span className="bag-image-upload-icon"><i className="bx bx-camera" /></span>
                              <strong>Modifier la photo</strong>
                            </span>
                          </>
                        ) : (
                          <span className="bag-image-upload-empty">
                            <span className="bag-image-upload-icon"><i className="bx bx-image-add" /></span>
                            <strong>Glissez votre photo ici</strong>
                            <span>ou cliquez pour sélectionner un fichier</span>
                            <small>JPG, PNG ou WEBP · 5 Mo maximum</small>
                          </span>
                        )}
                      </button>

                      {imageError && <div className="text-danger font-size-12 mt-2">{imageError}</div>}

                      <FormGroup className="d-none">
                        <Input
                          type="file"
                          accept="image/jpeg,image/png,image/webp"
                          innerRef={fileInputRef}
                          onChange={handleImageChange}
                        />
                      </FormGroup>
                    </div>
                  </Col>
                </Row>

                <Nav variant="tabs" activeKey={activeTab} className="mb-3">
                  {["fr", "en", "ar"].map((lang) => (
                    <NavItem tag="li" key={lang} className={`mx-1 rounded-5 px-1 ${activeTab === lang ? 'bg-light' : ''}`}>
                      <NavLink
                        to="#"
                        className={classnames({ active: activeTab === lang })}
                        onClick={() => setActiveTab(lang)}
                      >
                        {flags[lang]} {props.t(lang.toUpperCase())}
                      </NavLink>
                    </NavItem>
                  ))}
                </Nav>

                {/* Contenu des onglets */}
                <TabContent activeTab={activeTab}>
                  {["fr", "en", "ar"].map((lang) => (
                    <TabPane key={lang} tabId={lang}>
                      <FormGroup className="mb-3">
                        <Label htmlFor={`name${lang}`}>
                          {props.t("Nom")} ({lang.toUpperCase()})
                        </Label>
                        <Input
                          type="text"
                          id={`name${lang}`}
                          value={formData.translations[lang].name}
                          onChange={(e) => handleTranslationChange(e, lang, "name")}
                        />
                      </FormGroup>
                      <FormGroup className="mb-3">
                        <Label htmlFor={`description${lang}`}>
                          {props.t("Description")} ({lang.toUpperCase()})
                        </Label>
                        <Input
                          type="textarea"
                          id={`description${lang}`}
                          rows={3}
                          value={formData.translations[lang].description}
                          onChange={(e) => handleTranslationChange(e, lang, "description")}
                        />
                      </FormGroup>
                    </TabPane>
                  ))}
                </TabContent>
              </div>

              <Row className="mb-3">
                <Col md={6}>
                  <FormGroup controlId="price">
                    <Label>{props.t("Prix Remisé")}</Label>
                    <Input
                      type="number"
                      name="price"
                      value={formData.price}
                      onChange={handleChange}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup controlId="realPrice">
                    <Label>{props.t("Prix Réel")}</Label>
                    <Input
                      type="number"
                      name="realPrice"
                      value={formData.realPrice}
                      onChange={handleChange}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>

              <div className="d-flex justify-content-end mb-5">
                <Button color="secondary" onClick={() => navigate("/bags")} className="px-4">
                  <i className="bx bx-x" /> {props.t("Annuler")}
                </Button>
                <Button type="submit" color="primary" className="ms-3 px-4">
                  <i className="bx bx-check" /> {id ? props.t("Modifier") : props.t("Ajouter")}
                </Button>
              </div>
            </Form>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
};

export default withTranslation()(BagForm);
